import React from 'react';
import { Button } from '@/components/ui/button';

const BookingSummary = ({ selectedChildren, bookingDetails, onConfirmBooking }) => {
    const entryFeePerChild = 250;
    const additionalHourRate = 150;

    const numberOfChildren = selectedChildren.length;
    const entryFees = numberOfChildren * entryFeePerChild;

    const additionalHours = bookingDetails.duration - 1; // Assuming first hour is included in entry fee
    const additionalHoursCost = additionalHours > 0 ? additionalHours * additionalHourRate * numberOfChildren : 0;

    const subtotal = entryFees + additionalHoursCost;
    const cgstRate = 0.09; // 9%
    const sgstRate = 0.09; // 9%

    const cgst = subtotal * cgstRate;
    const sgst = subtotal * sgstRate;
    const total = subtotal + cgst + sgst;

    console.log(bookingDetails,selectedChildren);
    return (
        <div className='h-full bg-accent/10 mt-4 p-4 rounded-lg'>
            <h4 className='text-lg font-bold mb-4'>Booking Details</h4>
            <div className='space-y-2'>
                <div className='flex justify-between'>
                    <span>Entry Fees ({numberOfChildren} Children x {entryFeePerChild} Rs):</span>
                    <span>{entryFees.toFixed(2)} Rs</span>
                </div>
                {bookingDetails.duration > 1 && (
                    <div className='flex justify-between'>
                        <span>
                            Additional Hours ({additionalHours} Hrs x {additionalHourRate} Rs):
                            <br></br>
                            <span className='text-sm text-muted-foreground'> ({additionalHours} Hrs X {additionalHourRate} Rs) X {numberOfChildren} children </span>
                        </span>
                        <span>{additionalHoursCost.toFixed(2)} Rs</span>
                    </div>
                )}
                <div className='flex justify-between font-bold border-t pt-2 mt-2'>
                    <span>Subtotal:</span>
                    <span>{subtotal.toFixed(2)} Rs</span>
                </div>
                <div className='flex justify-between'>
                    <span>CGST ({cgstRate * 100}%):</span>
                    <span>{cgst.toFixed(2)} Rs</span>
                </div>
                <div className='flex justify-between'>
                    <span>SGST ({sgstRate * 100}%):</span>
                    <span>{sgst.toFixed(2)} Rs</span>
                </div>
                <div className='flex justify-between font-bold text-xl border-t pt-2 mt-2'>
                    <span>Total:</span>
                    <span>{total.toFixed(2)} Rs</span>
                </div>
            </div>
            <Button className='w-full mt-6' onClick={onConfirmBooking}>Confirm Booking</Button>
        </div>
    );
};

export default BookingSummary;